import { get } from "../api.ts";
import { wsBase } from "../state.ts";
import type { AuditRow } from "../types.ts";
import { append, h, whenTime } from "../ui.ts";

const WHAT: Record<string, string> = {
  invite: "invited",
  suspend: "suspended",
  restore: "restored",
  remove: "removed",
  role: "changed the role of",
  personas: "changed the buddies of",
  credit_cap: "changed the credit cap of",
  group: "changed groups",
  lead: "changed a lead:",
  track_upload: "added a company track",
  track_delete: "deleted a company track",
  assign: "gave a track",
  unassign: "withdrew a track from",
  reminder: "sent a reminder",
  export: "downloaded the CSV",
};

/** One plain sentence per entry, e.g. "owner@acme.com suspended ravi@acme.com". */
export function auditSentence(e: Pick<AuditRow, "what" | "actor" | "subject" | "after" | "before">): string {
  const who = e.actor ?? "Someone";
  const verb = WHAT[e.what] ?? e.what;
  const after = (e.after ?? {}) as Record<string, unknown>;
  const before = (e.before ?? {}) as Record<string, unknown>;
  let detail = "";
  if (e.what === "invite" && typeof after.email === "string" && !e.subject) detail = ` ${after.email}`;
  if ((e.what === "track_upload" || e.what === "track_delete") && typeof (after.title ?? before.slug) === "string") detail = ` ${String(after.title ?? before.slug)}`;
  if (e.what === "assign" && typeof after.track === "string") detail = ` (${after.track}${typeof after.people === "number" && after.people > 1 ? ` to ${after.people} people` : ""})`;
  if (e.what === "role" && typeof after.role === "string") detail = ` to ${after.role}`;
  if (e.what === "remove" && after.deleted_training === true) detail = ", and deleted their training progress";
  if (e.what === "remove" && after.left === true) return `${who} left the company`;
  return `${who} ${verb}${e.subject ? ` ${e.subject}` : ""}${detail}`;
}

export async function renderActivity(root: HTMLElement) {
  const { entries } = await get<{ entries: AuditRow[] }>(`${wsBase()}/audit?limit=300`);
  const ul = h("ol", { class: "log" });
  for (const e of entries) ul.append(h("li", null, h("time", { datetime: e.at }, whenTime(e.at)), h("span", null, auditSentence(e))));
  append(
    root,
    h("header", { class: "page-head" }, h("div", null, h("h1", null, "Activity"), h("p", { class: "muted" }, "Every change to people, groups, tracks and access, newest first."))),
    entries.length ? ul : h("p", { class: "empty" }, "Nothing has changed yet."),
  );
}
